// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tf-2";
export var container = "_tf-4";
export var dismissButton = "_tf-3";
export var hasPaddingBottom = "_tf-6";
export var last = "_tf-e";
export var scrollbarThumb = "_tf-c";
export var scrollbarTrack = "_tf-b";
export var selected = "_tf-9";
export var spin = "_tf-1";
export var spinning = "_tf-0";
export var suggestionItem = "_tf-d";
export var suggestionsPanel = "_tf-5";
export var tonePill = "_tf-8";
export var tonesContainer = "_tf-7";
export var unselected = "_tf-a";